// extracted by mini-css-extract-plugin
module.exports = {"button":"_3-pMq","hiddenLabel":"_1JTZG"};